import * as moment from 'moment';
import * as _ from 'lodash';
import { Component, SimpleChanges, OnInit, AfterViewInit, AfterViewChecked, Input, Output, EventEmitter, ViewChildren, QueryList, ChangeDetectionStrategy, SimpleChange, OnChanges } from '@angular/core';
import { Sector, Booking, Addon, AddonOption, TpProduct, OptionValueEntityInstance, Totals } from '../../../../../models/booking.model';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { ErrorService } from 'app/shared/services/error.service';
import { BookingService } from 'app/shared/services/booking.service';
import { SectorAddonsService } from 'app/shared/services/sector-addons.service';
import { InitialDataService } from 'app/initial-data.service';
import { TravelProductService, UpdateTourOnBookingOption } from '../../../../../services/travel-product.service';
import { CartTotalService } from '../../../../../services/cart-total.service';

@Component({
    selector: 'gaweb-open-addons',
    templateUrl: './open-addons.component.html'
})

export class OpenAddonsComponent implements OnInit, AfterViewInit {

    @Input() openAddons: Array<Addon>;
    @Input() booking: any;

    constructor(
        private travelPackageService: TravelProductService,
        private bookingsService: BookingService,
        private initialDataService: InitialDataService,
        private localStorageService: LocalStorageService,
        private errorService: ErrorService,
        private sectorAddonsService: SectorAddonsService,
        private cartTotalService: CartTotalService
    ) { }

    ngOnInit(){
        console.log(this.openAddons.length);
    }

    ngAfterViewInit() {

    }

    hasAvailableSectors(option){
        this.booking.Sectors.forEach(s => {
            s.Addons.forEach(a => {
                if(a.AddonOptions[0].ProductCode == option.ProductCode){
                    return false;
                }
            })
        })
        return true;
    }

    selectAssignSector(a: Addon, sector: Sector) {
        let tour = this.getTourForAddonOption(a.AddonOptions[0]);
        const options = new UpdateTourOnBookingOption(this.booking.BookingGuid, tour.TourGuid, sector.PassengerBoardingDate,
            tour.SelectedFareType, tour.SelectedFareTypeCurrency, tour.SelectedCurrencyAmount, false)
    }

    getTourForAddonOption(option: AddonOption): any {
        let tourGuid = "";
        this.booking.Tours.forEach(tour => {
            if(tour.SelectedFareType == option.ProductCode && tour.SelectedDate){
                tourGuid = tour.TourGuid;
            }
        });
        return tourGuid;
    }

    isValidSectorForAddon(option: AddonOption, sector: Sector){
        let isValid = true;
        console.log(sector.OriginName + ' -> ' + sector.DestinationName);
        console.log(option.ProductCode);
        sector.Addons.forEach(addon => {
            let o = addon.AddonOptions[0];
            if(o.ProductCode == option.ProductCode){
                if(o.CanPurchase === undefined || !o.CanPurchase){
                    isValid = false;
                }
            }
        });
        return isValid;
    }

    availableSectorAddon(option: AddonOption,s: Sector) {
        if(!!s.Addons || s.Addons.length > 0){
            s.Addons.forEach(a => {
                if(a.AddonOptions[0].ProductCode === option.ProductCode){
                    if(!!a.AddonOptions[0].CanPurchase && a.AddonOptions[0].CanPurchase){
                        console.log('availabelSectorAddon : true');
                        console.log(option);
                        console.log(s);
                        return true;
                    } 
                console.log('availabelSectorAddon : false');
                console.log(option);
                console.log(s);
                return false;
                }
            });
        }
        console.log('availabelSectorAddon : true');
        console.log(option);
        console.log(s);
return true;
    }

    getAddonIcon(addon) {
        const name = (addon.Title || addon.Name || '');

        if (addon.AddonType === 'MG') {
            return '/Assets/images/my-greyhound.png';
        }
        if (addon.AddonType === 'IN') {
            return '/Assets/images/premium.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('baggage') > -1) {
            return '/Assets/images/baggage.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('bicycle') > -1) {
            return '/Assets/images/surfboards.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('carbon') > -1) {
            return '/Assets/images/tree.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('upgrade') > -1) {
            return '/Assets/images/upgrade.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('mask') > -1) {
            return '/Assets/images/facemask.png';
        }
        if (addon.AddonType === 'TB') {
            return '/Assets/images/taxback.png';
        }
        return '';
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/open-addons-wrapper/open-addons/open-addons.component.ts